import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from '@/store/slices/product.slice'; // Import your action creators
import * as api from '@/services/product'; // Import your API functions
import { PayloadAction } from '@reduxjs/toolkit';
import { isBoolean } from 'lodash';
import { IApiResponse } from '@/services/product/product.type';
import { GET_PRODUCT_ACION_TYPE } from '@/constant/product/product.const';

// Define action types
export interface GetProductAction extends PayloadAction<number> {
  type: 'product/getProducts';
}

function* getProducts(action: GetProductAction): Generator {
  try {
    const response: any = yield call(api?.fetchProduct as any, action?.payload);
    if (isValidProductResponse(response?.data)) {
      yield put(actions?.getProductsSuccess(response?.data));
    } else {
      yield put(actions?.getProductsFailure(response?.data));
    }
  } catch (error: any) {
    yield put(
      actions?.getProductsFailure(
        error?.response?.data || { message: error?.message },
      ),
    );
  }
}

function isValidProductResponse(response: IApiResponse): boolean {
  return (
    isBoolean(response?.success) &&
    response?.message === 'Product detail fetched.'
  );
}

function* productSaga(): Generator {
  // Watch for the specific action type
  yield takeLatest<GetProductAction>(GET_PRODUCT_ACION_TYPE, getProducts);
}

export default productSaga;
